import {
  IFlexiTicketSummary,
  IFlexiTicketSummaryWithQty,
  ISearchTicketResult,
  ISearchTicketResultWithQty,
} from '@nx-ng/types';
import { cloneDeep, sumBy } from 'lodash-es';
import { Basket, BasketItem } from '../client/src';
import { KnownPricePaymentMethod } from '@modules/ticket-fares-store';

export const addQuantityInBasketToFlexiItems = ({
  basket,
  items,
}: {
  basket?: Basket;
  items?: IFlexiTicketSummary[];
}): IFlexiTicketSummaryWithQty[] => {
  if (!items) {
    return [];
  }
  return items.map((item: IFlexiTicketSummary) => {
    const matchingBasketItems = basket?.basketItems.filter(
      (basketItem: BasketItem) => basketItem.ticketID === item.id
    );
    const count = sumBy(
      matchingBasketItems,
      (item: BasketItem) => item.quantity
    );
    return {
      ...item,
      count,
    };
  });
};

export const addQuantityInBasketToSearchResults = ({
  basket,
  items,
}: {
  basket?: Basket;
  items?: ISearchTicketResult[];
}): ISearchTicketResultWithQty[] => {
  if (!items) {
    return [];
  }
  return items.map((item: ISearchTicketResult) => {
    const oneOffItems = basket?.basketItems.filter(
      (basketItem: BasketItem) =>
        basketItem.ticketID === item.standardTicket.id &&
        basketItem.paymentMethodType === KnownPricePaymentMethod.OneOff
    );

    const standardCount = sumBy(
      oneOffItems,
      (item: BasketItem) => item.quantity
    );

    return {
      ...cloneDeep(item),
      standardTicket: {
        ...item.standardTicket,
        count: standardCount,
      },
    };
  });
};
